type NoteProps = {
    children: React.ReactNode;
    tone?: 'neutral' | 'warn';
};

/**
 * Caveats and errors. A rule on the left rather than a tinted box: a box says
 * "warning, skip me". A margin rule says "annotation", which is what these are.
 */
export function Note({ children, tone = 'neutral' }: NoteProps) {
    return (
        <p
            className={`border-l-2 py-0.5 pl-3.5 text-sm leading-relaxed ${
                tone === 'warn' ? 'border-error text-error' : 'border-border-strong text-text-muted'
            }`}
        >
            {children}
        </p>
    );
}
